/// <summary>
/// 릴레이 모드
/// </summary>
export enum ERelayMode {
  /// <summary>
  /// 사용 하지 않음
  /// </summary>
  NOT_USE,
  /// <summary>
  /// 인증 성공
  /// </summary>
  AUTH_OK,
  /// <summary>
  /// 인증 오류
  /// </summary>
  AUTH_ERROR,
  /// <summary>
  /// 입구
  /// </summary>
  ENTRANCE,
  /// <summary>
  /// 출구
  /// </summary>
  EXIT
}
